import React from 'react'

type LoaderSize = 'sm' | 'md' | 'lg'
type LoaderVariant = 'spinner' | 'dots' | 'pulse'

interface LoaderProps {
  size?: LoaderSize
  variant?: LoaderVariant
  className?: string
  color?: string
}

const sizeMap = {
  sm: {
    container: 'h-5 w-5',
    dot: 'h-1.5 w-1.5'
  },
  md: {
    container: 'h-8 w-8',
    dot: 'h-3 w-3'
  },
  lg: {
    container: 'h-12 w-12',
    dot: 'h-3 w-3'
  }
}

const Loader: React.FC<LoaderProps> = ({ size = 'md', variant = 'spinner', className = '', color = 'hsl(var(--primary))' }) => {
  if (variant === 'spinner') {
    return (
      <div className={`relative ${sizeMap[size].container} ${className}`}>
        <div
          className="absolute inset-0 rounded-full border-4 border-t-transparent border-r-transparent animate-spin shadow-md"
          style={{
            borderLeftColor: color,
            borderBottomColor: color
          }}
        ></div>
      </div>
    )
  }

  if (variant === 'pulse') {
    return <div className={`rounded-full animate-pulse-slow shadow-md ${sizeMap[size].container} ${className}`} style={{ backgroundColor: color }}></div>
  }

  if (variant === 'dots') {
    // 3 dots com delays uniformes (0, 150ms, 300ms) — efeito "onda" suave em
    // vez do "cambaleante" dos 4 dots com delays negativos desbalanceados.
    return (
      <div className={`flex justify-center items-center space-x-1.5 ${className}`}>
        <div className={`rounded-full animate-bounce ${sizeMap[size].dot}`} style={{ backgroundColor: color, animationDuration: '900ms' }}></div>
        <div className={`rounded-full animate-bounce [animation-delay:150ms] ${sizeMap[size].dot}`} style={{ backgroundColor: color, animationDuration: '900ms' }}></div>
        <div className={`rounded-full animate-bounce [animation-delay:300ms] ${sizeMap[size].dot}`} style={{ backgroundColor: color, animationDuration: '900ms' }}></div>
      </div>
    )
  }

  return null
}

export default Loader
